export default class AdminResourceActions {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPermissionsEndpoint}/resource-action`, {
      params
    })
  }

  fetch(resource_action_id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPermissionsEndpoint}/resource-action/${resource_action_id}`)
  }

  create(payload) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminPermissionsEndpoint}/resource-action`, payload);
  }

  update(resource_action_id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPermissionsEndpoint}/resource-action/${resource_action_id}`, payload)
  }

  delete(resource_action_id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminPermissionsEndpoint}/resource-action/${resource_action_id}`)
  }
}
